const sketchContext = {
  TWO_PI: Math.PI * 2,
  sin: Math.sin,
  cos: Math.cos,
  random (min, max) {
    if (Array.isArray(min)) return min[Math.floor(Math.random() * min.length)]
    if (max === undefined) return Math.random() * min
    return min + Math.random() * (max - min)
  }
}

function Particle( x, y, radius ) {
  this.init( x, y, radius )
}

Particle.prototype = {
  init: function( x, y, radius ) {
    this.alive = true

    this.radius = radius || 10
    this.wander = 0.15
    this.theta = sketchContext.random( sketchContext.TWO_PI )
    this.drag = 0.92
    this.color = '#fff'

    this.x = x || 0.0
    this.y = y || 0.0

    this.vx = 0.0
    this.vy = 0.0
  },

  move: function() {
    this.x += this.vx
    this.y += this.vy

    this.vx *= this.drag
    this.vy *= this.drag

    this.theta += sketchContext.random( -0.5, 0.5 ) * this.wander
    this.vx += sketchContext.sin( this.theta ) * 0.1
    this.vy += sketchContext.cos( this.theta ) * 0.1

    this.radius *= 0.96
    this.alive = this.radius > 0.5
  },

  draw: function( ctx ) {
      ctx.beginPath()
      ctx.arc( this.x, this.y, this.radius, 0, sketchContext.TWO_PI )
      ctx.fillStyle = this.color
      ctx.fill()
  }
}

const MAX_PARTICLES = 280
const COLOURS = [ '#69D2E7', '#A7DBD8', '#E0E4CC', '#F38630', '#FA6900', '#FF4E50', '#F9D423' ]

// Own the RAF: sketch-js 1.1.3 keeps scheduling frames even after destroy().
export const initConfetti = (container) => {
  const canvas = document.createElement('canvas')
  canvas.width = window.innerWidth
  canvas.height = window.innerHeight
  container.appendChild(canvas)
  const context = canvas.getContext('2d')
  let particles = []
  let frame = null
  let destroyed = false
  let startedAt = null

  const destroy = () => {
    if (destroyed) return
    destroyed = true
    if (frame !== null) cancelAnimationFrame(frame)
    frame = null
    particles = []
    if (canvas.parentNode) canvas.parentNode.removeChild(canvas)
  }

  const draw = (now) => {
    frame = null
    if (destroyed) return
    if (startedAt === null) startedAt = now
    // Wall-clock bound also covers low frame rates and background throttling.
    if (!context || now - startedAt >= 8000) return destroy()
    context.clearRect(0, 0, canvas.width, canvas.height)
    context.globalCompositeOperation = 'lighter'
    particles = particles.filter(particle => {
      particle.move()
      if (particle.alive) particle.draw(context)
      return particle.alive
    })
    if (!particles.length) return destroy()
    frame = requestAnimationFrame(draw)
  }

  return {
    makeBang (from, to, step) {
      if (destroyed) return
      const dx = to.x - from.x
      const dy = to.y - from.y
      const distance = Math.sqrt(dx * dx + dy * dy)
      if (!Number.isFinite(distance) || !Number.isFinite(step) || step <= 0 || distance === 0) {
        destroy()
        return
      }
      const count = Math.min(MAX_PARTICLES, Math.ceil(distance / step))
      particles = []
      for (let i = 0; i < count; i++) {
        const particle = new Particle(from.x + dx * i / count, from.y + dy * i / count,
          sketchContext.random(5, 40))
        particle.wander = sketchContext.random(0.5, 2)
        particle.color = sketchContext.random(COLOURS)
        particle.drag = sketchContext.random(0.9, 0.99)
        const theta = sketchContext.random(sketchContext.TWO_PI)
        const force = sketchContext.random(2, 8)
        particle.vx = Math.sin(theta) * force
        particle.vy = Math.cos(theta) * force
        particles.push(particle)
      }
      if (frame === null) frame = requestAnimationFrame(draw)
    },
    destroy
  }
}
